require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-تصميم-مواقع.json") })
        }
      }, "path---tags-تصميم-مواقع");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-تصميم-مواقع!./.cache/json/tags-تصميم-مواقع.json
// module id = 594
// module chunks = 231608221292675